import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11ab79b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"grid\" data-v-11ab79b3><div data-v-11ab79b3><h1 style=\"margin-left:0 !important;\" data-v-11ab79b3>Isabelle Baron</h1><video controls data-v-11ab79b3><source src=\"/videos/Final_Isabelle_Baron.mp4\" type=\"video/mp4\" data-v-11ab79b3></video></div><div data-v-11ab79b3><h1 style=\"margin-left:0 !important;\" data-v-11ab79b3>Kevin Morais</h1><video controls data-v-11ab79b3><source src=\"/videos/Final_Kevin_Morais.mp4\" type=\"video/mp4\" data-v-11ab79b3></video></div><div data-v-11ab79b3><h1 style=\"margin-left:0 !important;\" data-v-11ab79b3>Martine Bruneau</h1><video controls data-v-11ab79b3><source src=\"/videos/Final_Martine_Bruneau.mp4\" type=\"video/mp4\" data-v-11ab79b3></video></div><div data-v-11ab79b3><h1 style=\"margin-left:0 !important;\" data-v-11ab79b3>Nancy St-Gelais</h1><video controls data-v-11ab79b3><source src=\"/videos/Final_Nancy_St-Gelais.mp4\" type=\"video/mp4\" data-v-11ab79b3></video></div><div data-v-11ab79b3><h1 style=\"margin-left:0 !important;\" data-v-11ab79b3>Nelson Lepage</h1><video controls data-v-11ab79b3><source src=\"/videos/Final_Nelson_Lepage.mp4\" type=\"video/mp4\" data-v-11ab79b3></video></div><div data-v-11ab79b3><h1 style=\"margin-left:0 !important;\" data-v-11ab79b3>Pascale Dallaire</h1><video controls data-v-11ab79b3><source src=\"/videos/Final_Pascale_Dallaire.mp4\" type=\"video/mp4\" data-v-11ab79b3></video></div><div data-v-11ab79b3><h1 style=\"margin-left:0 !important;\" data-v-11ab79b3>Patrick Savoie</h1><video controls data-v-11ab79b3><source src=\"/videos/Final_Patrick_Savoie.mp4\" type=\"video/mp4\" data-v-11ab79b3></video></div><div data-v-11ab79b3><h1 style=\"margin-left:0 !important;\" data-v-11ab79b3>Pierre-Luc Gauthier</h1><video controls data-v-11ab79b3><source src=\"/videos/Pierre-Luc-Gauthier-V2.mp4\" type=\"video/mp4\" data-v-11ab79b3></video></div><div data-v-11ab79b3><h1 style=\"margin-left:0 !important;\" data-v-11ab79b3>Richard Bélanger</h1><video controls data-v-11ab79b3><source src=\"/videos/Final_Richard_Belanger.mp4\" type=\"video/mp4\" data-v-11ab79b3></video></div><div data-v-11ab79b3><h1 style=\"margin-left:0 !important;\" data-v-11ab79b3>Shirley Kennedy</h1><video controls data-v-11ab79b3><source src=\"/videos/Final_Shirley_Kennedy.mp4\" type=\"video/mp4\" data-v-11ab79b3></video></div></div>", 1)
const _hoisted_2 = { class: "grid" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = {
  for: "nom",
  class: "form-label"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = {
  for: "courriel",
  class: "form-label"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = {
  for: "candidat",
  class: "form-label"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "w-full cols-3" }
const _hoisted_14 = {
  for: "message",
  class: "form-label"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Toast),
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('elections')), 1),
    _hoisted_1,
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('poser_question')), 1),
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('nom_complet')), 1),
        _createVNode(_component_InputText, {
          type: "text",
          id: "nom",
          name: "nom",
          class: "form-input w-full",
          modelValue: _ctx.nom,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nom) = $event))
        }, null, 8, ["modelValue"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.nom.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "errorMessage",
            key: error.$uid
          }, [
            (error.$validator == 'required')
              ? (_openBlock(), _createElementBlock("label", _hoisted_5, _toDisplayString(_ctx.$t('errors.required')), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('courriel')), 1),
        _createVNode(_component_InputText, {
          type: "email",
          id: "courriel",
          name: "courriel",
          class: "form-input w-full",
          modelValue: _ctx.courriel,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.courriel) = $event))
        }, null, 8, ["modelValue"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.courriel.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "errorMessage",
            key: error.$uid
          }, [
            (error.$validator == 'required')
              ? (_openBlock(), _createElementBlock("label", _hoisted_8, _toDisplayString(_ctx.$t('errors.required')), 1))
              : _createCommentVNode("", true),
            (error.$validator == 'email')
              ? (_openBlock(), _createElementBlock("label", _hoisted_9, _toDisplayString(_ctx.$t('errors.email')), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('candidat')), 1),
        _createVNode(_component_Dropdown, {
          id: "candidat",
          name: "candidat",
          class: "form-input w-full",
          modelValue: _ctx.candidat,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.candidat) = $event)),
          options: _ctx.candidats
        }, null, 8, ["modelValue", "options"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.candidat.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "errorMessage",
            key: error.$uid
          }, [
            (error.$validator == 'required')
              ? (_openBlock(), _createElementBlock("label", _hoisted_12, _toDisplayString(_ctx.$t('errors.required')), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('question')), 1),
        _createVNode(_component_Textarea, {
          id: "message",
          name: "message",
          class: "form-input w-full",
          style: {"height":"100px","resize":"none"},
          modelValue: _ctx.message,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.message) = $event))
        }, null, 8, ["modelValue"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.message.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "errorMessage",
            key: error.$uid
          }, [
            (error.$validator == 'required')
              ? (_openBlock(), _createElementBlock("label", _hoisted_15, _toDisplayString(_ctx.$t('errors.required')), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("button", {
          class: "button button-primary",
          type: "button",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', 'floppy-disk'],
            class: "disquette"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('bouton.envoyer')), 1)
        ])
      ])
    ])
  ]))
}